/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import * as LocationApi from 'api/Location/LocationApi';
import ListExpandable from 'components/ListExpandable';
import ListRow from 'components/ListExpandable/ListRow';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
export default class UsersRoleExpandableList extends React.Component<*> {
  @observable users: Object = {};

  loadUsersPerRole = async (
    companyId: string,
    role: string,
    countryId: string,
    locationId: string
  ) => {
    if (!Object.prototype.hasOwnProperty.call(this.users, role)) {
      this.users[role] = locationId
        ? await LocationApi.getLocationyUsersPerRole(locationId, role)
        : countryId
        ? await LocationApi.getCountryUsersPerRole(companyId, role, countryId)
        : await LocationApi.getCompanyUsersPerRole(companyId, role);
    }

    return this.users[role];
  };

  getUrl = (accountId, userId, locationId, companyId) => {
    const filters = [
      { key: 'account', values: [accountId] },
      { key: 'user', values: [userId] },
      ...(locationId ? [{ key: 'location', values: [locationId] }] : []),
      ...(companyId ? [{ key: 'company_id', values: [companyId] }] : []),
    ];

    const url = NavigationService.formulateReportViewUri(`/assets/`, {
      page: 1,
      filters,
    });

    return url;
  };

  renderUserRole = (
    title: string,
    companyId: string,
    role: string,
    countryId: string,
    accountId: string,
    locationId: string,
    i: number
  ) => {
    const { t } = this.props;

    return (
      <ListExpandable
        key={i}
        title={title}
        onExpand={async () => await this.loadUsersPerRole(companyId, role, countryId, locationId)}
        render={(users: Array<Object>) => {
          if (!users) {
            return null;
          }

          return users.map((user: Object) => (
            <ListRow
              key={user.id}
              text={user.name}
              textRight={`${user.assets_count} ${t('general:asset', {
                count: user.assets_count,
              })}`}
              button={true}
              link={true}
              url={this.getUrl(
                accountId,
                user.user_id ? user.user_id : user.id,
                locationId,
                companyId
              )}
              buttonText={t('general:actions.view_asset', { count: user.assets_count })}
              buttonDisabled={user.assets_count < 1}
            />
          ));
        }}
      />
    );
  };

  reformatTitle(role: string): string {
    if (role.length && role.indexOf('_') > -1) {
      return role.split('_').join(' ');
    }

    return role;
  }

  render(): ?React.Element<*> {
    const details: Object = this.props.details;

    if (details.users_count.length === 0) {
      return null;
    }

    let list: React.Element<*>;
    let title: string;
    let i: number = 0;

    for (const role: string of Object.keys(details.users_count)) {
      title = `${this.reformatTitle(role)} (${details.users_count[role]})`;
      list = (
        <React.Fragment>
          {list}
          {this.renderUserRole(
            title,
            this.props.companyId,
            role,
            this.props.countryId,
            this.props.accountId,
            this.props.locationId,
            i
          )}
        </React.Fragment>
      );
      i++;
    }

    if (!list) {
      return null;
    }

    return (
      <section>
        <h3>{this.props.title}</h3>
        {list}
      </section>
    );
  }
}
